import { memo, useId } from 'react'

const DocIconInner = ({ kind = 'doc', label, color, size = 26, decorative = false, ...rest }) => {
  const uid = useId()
  const fillId = `docFill-${uid}`
  const clipId = `docClip-${uid}`

  const lbl = (label || kind || '').toUpperCase()
  const tone = color || `var(--doc-${kind}, var(--doc-default, currentColor))`
  const fontSize = lbl.length <= 3 ? 6.2 : 5.4

  const { style: restStyle, ...restWithoutStyle } = rest

  const a11yProps = decorative ? { 'aria-hidden': 'true' } : { role: 'img', 'aria-label': lbl }

  return (
    <svg
      width={size * (22 / 26)}
      height={size}
      viewBox="0 0 22 26"
      style={{
        color: tone,
        display: 'inline-block',
        verticalAlign: 'middle',
        overflow: 'visible',
        ...restStyle,
      }}
      {...a11yProps}
      {...restWithoutStyle}
    >
      <defs>
        <linearGradient id={fillId} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#f7f9fd" />
        </linearGradient>
        <clipPath id={clipId}>
          <path d="M2 1 h12 l6 6 v17 a1 1 0 0 1 -1 1 H2 a1 1 0 0 1 -1 -1 V2 a1 1 0 0 1 1 -1 z" />
        </clipPath>
      </defs>

      {/* paper body */}
      <path
        d="M2 1 h12 l6 6 v17 a1 1 0 0 1 -1 1 H2 a1 1 0 0 1 -1 -1 V2 a1 1 0 0 1 1 -1 z"
        fill={`url(#${fillId})`}
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      {/* folded corner */}
      <path d="M14 1 v5 a1 1 0 0 0 1 1 h5" fill="currentColor" opacity=".18" />
      <path
        d="M14 1 v6 h6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      {/* faint inner lines */}
      <path
        d="M4 12 h10"
        stroke="currentColor"
        strokeWidth="1"
        opacity=".35"
        strokeLinecap="round"
      />
      <path
        d="M4 15 h13"
        stroke="currentColor"
        strokeWidth="1"
        opacity=".25"
        strokeLinecap="round"
      />

      {/* code band */}
      <g clipPath={`url(#${clipId})`}>
        <rect x="0" y="16" width="22" height="9" fill="currentColor" />
        <text
          x="11"
          y="22.5"
          textAnchor="middle"
          fontWeight="800"
          fontSize={fontSize}
          letterSpacing=".3"
          fill="#ffffff"
        >
          {lbl}
        </text>
      </g>
    </svg>
  )
}

export const DocIcon = memo(DocIconInner)
